import React from 'react';
import type { ObjectType } from '@src/types/misc';

type TStyleProps = {
  active: boolean;
  style?: ObjectType;
  onClick: () => void;
};

type TButtonProps = TStyleProps & {
  children: React.ReactElement | string;
  image: string;
};

function Button(props: TButtonProps): React.ReactElement {
  const { children, image, active, style, onClick } = props;

  return (
    <button type="button" style={style} onClick={onClick} data-active={active}>
      <img src={image} />
      {children}
    </button>
  );
}

export default Button;
